import React, { Fragment } from 'react'

import Sidebar from './components/Sidebar/Sidebar'

export default function SidebarOnlyLayout(props) {
  return (
    <div id="app" className={props.appClassName}>
      <div className="app-body">
        <Sidebar {...props} isLogoVisible={true} />
        <Fragment>
          {props.children}
        </Fragment>
      </div>
    </div>
  )
}
